import { render, staticRenderFns } from "./ConfigView.vue?vue&type=template&id=5a743174&scoped=true&"
import script from "./ConfigView.vue?vue&type=script&lang=ts&"
export * from "./ConfigView.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigView.vue?vue&type=style&index=0&id=5a743174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a743174",
  null
  
)

export default component.exports